// Blob → base64 (no data-URL prefix). PdfModal consumes base64; /getfile.sz returns a blob.
export function convertBlobToBase64(blob) {
   return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => resolve(reader.result.split(",")[1]);
      reader.onerror = reject;
   });
}
